import React from 'react';
import PropTypes from 'prop-types';
import { FormFeedback } from 'reactstrap';
import Select from 'react-select';
import classnames from 'classnames';
import 'react-select/dist/react-select.css';

const SelectControl = props => {
  const {
    multi,
    input,
    children,
    meta: { touched, error },
  } = props;

  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'has-danger';
      errorText = error;
    } else {
      validationState = 'has-success';
    }
  }

  let optionChildren = children;
  if (children && !{}.hasOwnProperty.call(children, 'length')) {
    optionChildren = [children];
  }

  const options =
    optionChildren &&
    optionChildren.map(child => ({
      value: child.props.value,
      label: child.props.children,
    }));

  const onChange = multi
    ? values => input.onChange(values.map(val => val.value))
    : val => input.onChange(val.value);

  return (
    <div className={classnames('mobile-data-list-row', validationState)}>
      <Select
        {...input}
        multi={multi}
        clearable={false}
        options={options}
        onChange={onChange}
        onBlur={() => input.onBlur(input.value)}
      />
      {errorText && <FormFeedback>{errorText}</FormFeedback>}
    </div>
  );
};

SelectControl.propTypes = {
  input: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  meta: PropTypes.shape({}),
  multi: PropTypes.bool,
};

SelectControl.defaultProps = {
  multi: false,
};

export default SelectControl;
